<template>
  <custom-dialog
      :widthDialog="'800px'"
      :classDialog="'advance-search-dialog'"
      :openDialog="isOpen"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('dialogClosed')"
  >
    <template #body>
      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>
      <el-form :model="form" label-position="right">
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Tên công việc" class="formItem">
              <el-input
                  v-model="searchForm.taskTitle"
                  size="medium"
                  class="style-fullWidth input-none__border has-border__bottom"
                  placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Mô tả" class="formItem">
              <el-input
                  v-model="searchForm.taskDetail"
                  size="medium"
                  class="style-fullWidth input-none__border has-border__bottom"
                  placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Hạn hoàn thành" class="formItem">
              <el-date-picker
                  v-model="deadlineRange"
                  type="daterange"
                  range-separator=" - "
                  start-placeholder="-"
                  end-placeholder="-"
                  align="bottom"
                  format="dd/MM/yyyy"
                  class="style-fullWidth input-none__border has-border__bottom"
                  size="medium"
                  @change="deadlineRangeChanged"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24" v-if="!isDisableAssignerFilter">
            <el-form-item label="Người giao:" class="formItem">
              <el-select
                  clearable
                  class="style-fullWidth input-none__border has-border__bottom"
                  v-model="searchForm.assignerUserDeptRoleId"
                  filterable
                  placeholder="Người giao"
                  size="medium"
              >
                <el-option
                    v-for="item in assigners"
                    :key="item.id"
                    :value="item.id"
                    :label="
                    `${item.fullName} (${item.positionName} - ${item.deptName})`
                  "
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24" v-if="!isDisableReceiverFilter">
            <el-form-item label="Người thực hiện:" class="formItem">
              <el-select
                  clearable
                  class="style-fullWidth input-none__border has-border__bottom"
                  v-model="searchForm.receiverUserDeptRoleId"
                  filterable
                  placeholder="Người thực hiện"
                  size="medium"
              >
                <el-option
                    v-for="item in receivers"
                    :key="item.id"
                    :value="item.id"
                    :label="
                    `${item.fullName} (${item.positionName} - ${item.deptName})`
                  "
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Tiến độ:" class="formItem">
              <el-select
                  clearable
                  class="style-fullWidth input-none__border has-border__bottom"
                  v-model="searchForm.progressStatus"
                  filterable
                  placeholder="Tiến độ"
                  size="medium"
              >
                <el-option
                    v-for="item in progressStatus"
                    :key="item.id"
                    :value="item.id"
                    :label="
                    `${item.fullName} `
                  "
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="search">
          <i class="fas fa-search"></i>
          &nbsp;Tìm kiếm
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="reset">
          <i class="fas fa-undo"></i>
          &nbsp;Khởi tạo
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import utils from "../../../services/utils";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import CustomDialog from "../../common/custom-dialog";

export default {
  name: "task-advance-search-dialog",
  props: [
    "isOpen",
    "form",
    "isDisableDeptAssignerFilter",
    "isDisableAssignerFilter",
    "isDisableReceiverFilter"
  ],
  components: {
    CustomDialog
  },

  data() {
    return {
      assigners: [],
      progressStatus: [
        {id: 'all',fullName: 'Tất cả'},
        {id: 'quaHan',fullName: 'Quá hạn'},
        {id: 'denHan',fullName: 'Đến hạn'},
        {id: 'chuaDenHan',fullName: 'Chưa đến hạn'}
        ],
      receivers: [],
      deadlineRange: null,
      searchForm: {
        fromDeadline: null,
        toDeadline: null,
        taskTitle: null,
        taskDetail: null,
        assignerUserDeptRoleId: null,
        progressStatus: null,
        assignerUserDeptRole: null
      }
    };
  },

  created() {
    this.initForm();
    this.loadAssigners();
    this.loadReceivers();
  },

  methods: {

    deadlineRangeChanged() {
      utils.timeRangeChanged(this.deadlineRange, (from_, to_) => {
        this.searchForm.fromDeadline = from_;
        this.searchForm.toDeadline = to_;
      });
    },

    loadAssigners() {
      return userDeptRoleViewService
          .findAllAssignersForTask()
          .then(response => {
            this.assigners = (response.data || []).sort((node1, node2) =>
                utils.compareUserDeptRoleView(node1, node2)
            );
          });
    },

    loadReceivers() {
      return userDeptRoleViewService
          .findAllReceiversForTaskV2()
          .then(response => {
            this.receivers = (response.data || []).sort((node1, node2) =>
                utils.compareUserDeptRoleView(node1, node2)
            );
          });
    },

    initForm() {
      this.searchForm.fromDeadline = this.form.fromDeadline;
      this.searchForm.toDeadline = this.form.toDeadline;
      this.searchForm.taskTitle = this.form.taskTitle;
      this.searchForm.taskDetail = this.form.taskDetail;
      this.searchForm.assignerUserDeptRoleId = this.form.assignerUserDeptRoleId;
      this.searchForm.progressStatus = this.form.progressStatus || 'all';
      this.searchForm.assignerUserDeptRole = this.form.assignerUserDeptRole;
      this.initDeadlineRange();
    },

    initDeadlineRange() {
      this.deadlineRange = utils.initTimeRange(
          this.searchForm.fromDeadline,
          this.searchForm.toDeadline
      );
    },

    search() {
      this.$emit("doSearch", {
        advanceSearchForm: {
          fromDeadline: this.searchForm.fromDeadline,
          toDeadline: this.searchForm.toDeadline,
          taskTitle: this.searchForm.taskTitle,
          taskDetail: this.searchForm.taskDetail,
          assignerUserDeptRoleId: this.searchForm.assignerUserDeptRoleId,
          progressStatus: this.searchForm.progressStatus,
          assignerUserDeptRole: this.searchForm.assignerUserDeptRole,
          receiverUserDeptRoleId: this.searchForm.receiverUserDeptRoleId
        }
      });
      this.$emit("closeDialog");
    },

    reset() {
      this.searchForm.fromDeadline = null;
      this.searchForm.toDeadline = null;
      this.searchForm.taskTitle = null;
      this.searchForm.taskDetail = null;
      this.searchForm.assignerUserDeptRoleId = null;
      this.searchForm.assignerUserDeptRole = null;
      this.searchForm.progressStatus = null;
      this.initDeadlineRange();
    }
  }
};
</script>

<style scoped>
.form {
  padding: 12px 20px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/job/components/advanceSearch.vue